module.exports = __webpack_public_path__ + "img/flag-zambia.2398c513.png";